import FormatKey from './FormatKey';
const PrintVal=({value})=>{
	if(typeof value === 'object'){
		return <div className="pl-5 flex flex-col gap-1 mt-1">
			{
				Object.entries(value).map(([key, val], index)=>{
					return <p key={index}><FormatKey name={key} />: {val ? (Array.isArray(val) ? val.join(', ') : val) : ''}</p>
				})
			}
		</div>
	}else{
		return value;
	}
	return typeof value;
}

export default PrintVal